var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHannegiImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 71,
    viewBox: "0 0 67 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.723 70.9998H4.28088C1.51328 70.9998 -0.524999 68.4239 0.119879 65.7486L4.61867 47.037C7.81619 33.7371 19.7618 24.3545 33.5 24.3545C47.2382 24.3545 59.18 33.7332 62.3813 47.037L66.8801 65.7486C67.525 68.4277 65.4867 70.9998 62.7191 70.9998H62.723Z",
    fill: "#F8ECE8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.4408 43.8729C27.4372 43.8729 28.245 42.7726 28.245 41.4154C28.245 40.0582 27.4372 38.958 26.4408 38.958C25.4445 38.958 24.6367 40.0582 24.6367 41.4154C24.6367 42.7726 25.4445 43.8729 26.4408 43.8729Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.5629 43.8997C41.5593 43.8997 42.367 42.7995 42.367 41.4423C42.367 40.0851 41.5593 38.9849 40.5629 38.9849C39.5665 38.9849 38.7588 40.0851 38.7588 41.4423C38.7588 42.7995 39.5665 43.8997 40.5629 43.8997Z",
    fill: "#25569D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.5039 47.3049C34.3307 47.3049 35.0009 46.8172 35.0009 46.2157C35.0009 45.6141 34.3307 45.1265 33.5039 45.1265C32.6771 45.1265 32.0068 45.6141 32.0068 46.2157C32.0068 46.8172 32.6771 47.3049 33.5039 47.3049Z",
    fill: "#A3887E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.4757 57.5398C22.1264 57.5398 21.7809 57.3831 21.5544 57.0812C21.1744 56.5767 21.2742 55.8582 21.7847 55.4799C21.8769 55.4111 23.9996 53.7945 23.8077 51.2988C23.658 49.3955 22.2799 48.1993 21.8577 47.8783C21.3548 47.4923 21.2589 46.7738 21.6466 46.2731C22.0343 45.7725 22.7559 45.6769 23.2588 46.0629C23.8691 46.5292 25.8767 48.2758 26.0993 51.123C26.3872 54.792 23.4967 57.0659 23.1666 57.3105C22.9593 57.4634 22.7175 57.5398 22.4757 57.5398Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.5282 57.5398C44.2864 57.5398 44.0446 57.4634 43.8373 57.3105C43.5072 57.0621 40.6168 54.792 40.9046 51.123C41.1273 48.2758 43.1349 46.5292 43.7452 46.0629C44.248 45.6769 44.9697 45.7725 45.3574 46.2731C45.7451 46.7738 45.6491 47.4923 45.1463 47.8783C44.7279 48.1993 43.346 49.3955 43.1963 51.2988C43.0005 53.7945 45.1271 55.4111 45.2192 55.4799C45.7259 55.8582 45.8295 56.5767 45.4495 57.0812C45.223 57.3793 44.8776 57.5398 44.5282 57.5398Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.4041 54.0698C33.1469 54.0698 32.8897 54.0659 32.6249 54.0545C28.2604 53.8596 25.535 52.1665 24.5677 51.4442C24.0572 51.0658 23.9535 50.3473 24.3336 49.8428C24.7136 49.3345 25.4391 49.2313 25.9419 49.6097C26.5676 50.0721 28.8976 51.597 32.7285 51.769C37.7455 51.9907 40.9238 49.6365 41.0582 49.5371C41.5649 49.1511 42.2827 49.2504 42.6704 49.7511C43.0542 50.2518 42.9583 50.9703 42.4554 51.3563C42.0754 51.6467 38.7205 54.0736 33.4079 54.0736L33.4041 54.0698Z",
    fill: "#25569D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.262 26.4032C33.189 26.4032 33.1161 26.3956 33.0432 26.3841C32.4175 26.2656 32.0106 25.6656 32.1296 25.0427C32.4444 23.4031 32.7015 20.189 30.8514 17.0665C28.7325 13.497 24.606 11.3414 20.0266 11.479C19.447 11.4523 18.8635 10.9975 18.8443 10.3669C18.829 9.73628 19.328 9.20887 19.9614 9.18976C25.3929 9.06746 30.2871 11.6128 32.8321 15.9009C35.0661 19.673 34.7667 23.5178 34.3905 25.4707C34.283 26.0172 33.8032 26.3994 33.262 26.3994V26.4032Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.0219 14.5819C20.06 12.2152 20.8237 9.53808 19.7277 8.60246C18.6317 7.66685 16.091 8.82698 14.0529 11.1937C12.0148 13.5604 11.251 16.2375 12.347 17.1731C13.443 18.1087 15.9837 16.9486 18.0219 14.5819Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.4681 11.137C20.731 10.4406 20.525 7.66521 19.0079 4.93801C17.4908 2.21081 15.2372 0.564543 13.9743 1.26097C12.7113 1.9574 12.9173 4.7328 14.4344 7.46C15.9515 10.1872 18.2052 11.8335 19.4681 11.137Z",
    fill: "#25569D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHannegiImg);
export default __webpack_public_path__ + "static/media/hannegi_img.2d9872e68dc40df722d65f6ddf55c1fa.svg";
export { ForwardRef as ReactComponent };